"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _MobileCTA = _interopRequireDefault(require("./CTA/MobileCTA/MobileCTA"));
var _SideCTA = _interopRequireDefault(require("./CTA/SideCTA/SideCTA"));
var _ButtonCTA = _interopRequireDefault(require("./CTA/ButtonCTA/ButtonCTA"));
var _useGuidedSellingStatus = require("../hooks/app/useGuidedSellingStatus");
var _useCTA2 = require("../hooks/app/useCTA");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var buttonAppearanceMap = {
  primaryButton: 'primary',
  secondaryButton: 'secondary'
};
var CTAentryPoints = function CTAentryPoints() {
  var _useGuidedSellingStat = (0, _useGuidedSellingStatus.useGuidedSellingStatus)(),
    openGuidedSellingModal = _useGuidedSellingStat.openGuidedSellingModal,
    isGuidedSellingModalOpen = _useGuidedSellingStat.isGuidedSellingModalOpen;
  var _useCTA = (0, _useCTA2.useCTA)(),
    content = _useCTA.content,
    appearance = _useCTA.appearance,
    showCTA = _useCTA.showCTA,
    showExtendedCTA = _useCTA.showExtendedCTA;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showCTA ? appearance === 'ribbon' ? [/*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm",
    key: "0"
  }, /*#__PURE__*/_react.default.createElement(_MobileCTA.default, {
    title: content.popupTitle,
    description: content.popupText,
    primaryButtonText: content.popupOkButtonText,
    secondaryButtonText: content.popupCancelButtonText,
    text: content.floatingButtonText,
    primaryButtonFunction: openGuidedSellingModal,
    showPopUp: false,
    showFloatingButton: !isGuidedSellingModalOpen,
    controlShowExtentedCTA: showExtendedCTA
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true,
    key: "1"
  }, /*#__PURE__*/_react.default.createElement(_SideCTA.default, {
    title: content.popupTitle,
    content: content.popupText,
    secondaryButtonText: content.popupCancelButtonText,
    primaryButtonText: content.popupOkButtonText,
    sideText: content.ribbonText,
    primaryButtonFunction: openGuidedSellingModal,
    showPopUP: false,
    controlShowExtentedCTA: showExtendedCTA
  }))] : null : null, ['primaryButton', 'secondaryButton'].includes(appearance) ? /*#__PURE__*/_react.default.createElement(_ButtonCTA.default, {
    appearance: buttonAppearanceMap[appearance],
    text: content.inFlowButtonText,
    launchFunction: openGuidedSellingModal
  }) : null);
};
var _default = CTAentryPoints;
exports.default = _default;